const Button = function (props) {
    const {
        type = "green",
        text,
        onClick,
        isDisabled = false,
        cls = ''
    } = props;

    return (
        <div className="button--wrapper">
            <button className={`button button__${type} ${cls}`} disabled={isDisabled} onClick={(e) => onClick(e)}>{text}</button>
        </div>
    )
}

export default Button